import { dew as _recordDew } from "./record";
var exports = {},
  _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.record = void 0;
  var record_1 = _recordDew();
  Object.defineProperty(exports, "record", {
    enumerable: true,
    get: function () {
      return record_1.record;
    }
  });
  return exports;
}